var _ = require('lodash');
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<li>\n	<div class="item send-item empty-item" data-rank="'+
((__t=(data.index))==null?'':__t)+
'">\n		<div class="main">\n			<div class="rank">'+
((__t=(data.index))==null?'':__t)+
'</div>\n			<div class="user">\n	            <div class="avatar">\n	            	<span class="ui-img ui-circle" node-id="profile" >?\n	            	</span>\n	            </div>\n	            <div class="info">\n	                <dl>\n	                  	<dd class="giftcount">\n	                    	'+
((__t=(UpAct.lang.template("虚位以待")))==null?'':__t)+
'\n	                  	</dd>\n	                </dl>\n	            </div>\n	        </div>\n	    </div>\n\n	</div>\n</li>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));



//////////////////
// WEBPACK FOOTER
// ./js/component/send-userlist/empty-item.tmpl
// module id = 59
// module chunks = 0 1